import { BackgroundImage, Image } from 'pcln-design-system'
import React from 'react'

const canvasMock =
  typeof document === 'object' ? document.createElement('canvas') : /* istanbul ignore next */ {}
canvasMock.width = canvasMock.height = 1

// If canvas supports webp, the returned Data URLs would  be prefixed with “data:“.
// Thus data starts at index 5, after the prefix.
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
export const detectWebPSupport = /* istanbul ignore next */ () =>
  canvasMock.toDataURL ? canvasMock.toDataURL('image/webp')?.indexOf('image/webp') === 5 : false

const withWebP = (Component) => {
  return function WebPImage({ image = '', imageWebP = '', ...passthroughProps }) {
    const finalImage =
      imageWebP && /* istanbul ignore next */ detectWebPSupport()
        ? /* istanbul ignore next */ imageWebP
        : image

    return <Component image={finalImage} src={finalImage} {...passthroughProps} />
  }
}

const WebPBackgroundImage = withWebP(BackgroundImage)

WebPBackgroundImage.displayName = 'WebPBackgroundImage'

const WebPImage = withWebP(Image)

WebPImage.displayName = 'WebPImage'

export { WebPImage }
export default WebPBackgroundImage
